import { useMemo } from 'react'
import { getReplyPreviewSnippet } from '@/utils/replyPreviewSnippet'
import styles from './index.module.scss'

export function useAiAskBarDerivedMemos({ variant, isExpanded, attachments, replyPreview }) {
  const imageAttachments = useMemo(() => attachments.filter((a) => Boolean(a.previewUrl)), [attachments])
  const docAttachments = useMemo(() => attachments.filter((a) => !a.previewUrl), [attachments])
  const replySnippet = useMemo(
    () =>
      replyPreview ? getReplyPreviewSnippet(replyPreview.text, replyPreview.attachmentCount) : '',
    [replyPreview],
  )

  const cardClassName = useMemo(() => {
    const base = styles.card
    const expanded = isExpanded ? styles.cardExpanded : null
    if (variant === 'compact') {
      return [base, styles.cardCompactVariant, expanded].filter(Boolean).join(' ')
    }
    if (variant === 'emailReply') {
      return [base, styles.cardEmailReplyVariant, expanded].filter(Boolean).join(' ')
    }
    return [base, isExpanded ? styles.cardExpanded : styles.cardCompact].filter(Boolean).join(' ')
  }, [isExpanded, variant])

  return { imageAttachments, docAttachments, replySnippet, cardClassName }
}
